'use client';
import EcoImg from 'eco-design/base/eco-img';
import DefaultStyle from 'lowcode/common/DefaultStyle';
import { useEffect, useState } from 'react';
// import 'swiper/scss';
import styles from './index.module.scss';

const icon1 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
        <g clipPath="url(#clip0_4830_4295)">
            <path
                d="M12.0204 21.8251C10.4208 21.9204 9.68192 22.7104 9.9121 23.2837C10.1442 23.857 11.7747 25.2969 14.5155 25.6816C17.2544 26.0663 19.9661 25.8907 21.001 25.8907C22.0338 25.8907 23.2562 25.7488 22.6257 25.2278C21.1595 24.0752 19.4927 23.1835 17.7031 22.5946C15.2989 21.8233 13.6181 21.7262 12.0204 21.8233V21.8251ZM6.32605 14.9601C6.43436 15.6287 7.15197 17.3319 9.22158 18.6242C10.8657 19.6551 12.7418 20.3928 14.7399 20.7887C16.2234 21.0912 17.6257 21.5039 17.1615 20.6636C16.6973 19.8232 15.1267 17.7371 12.856 16.2711C10.5852 14.8052 9.38789 14.6315 8.37825 14.426C7.36663 14.2206 6.21771 14.2953 6.32602 14.962L6.32605 14.9601ZM7.02237 8.05032C6.18871 8.05032 6.24482 8.79359 6.46727 9.43231C6.69163 10.0672 7.64519 11.9628 9.29122 13.1169C10.3898 13.8844 11.7806 14.5512 13.4633 15.1151C13.0881 13.0515 12.2834 11.4287 11.0494 10.2484C9.20029 8.47611 7.85602 8.0522 7.02237 8.0522V8.05032ZM10.7612 2.54862C10.4928 2.52356 10.2237 2.59032 10.0011 2.73724C9.89909 2.80352 9.81277 2.88985 9.74777 2.99059C9.68277 3.09133 9.64056 3.20419 9.6239 3.32178L9.58908 3.65046C9.49626 4.70746 9.66643 5.76822 10.0862 6.76922C10.7245 8.28191 11.6838 9.48271 12.9604 10.3642C13.2118 9.55742 13.3685 8.88885 13.4246 8.35474C13.5097 7.55171 13.5097 6.8271 12.9604 4.99508C12.7167 4.18082 12.1867 3.44502 11.3744 2.78767C11.1999 2.64971 10.986 2.56632 10.7612 2.54862Z"
                fill="url(#paint0_linear_4830_4295)"
            />
            <path
                d="M14.9986 0.260167C15.1859 0.263016 15.3761 0.324911 15.536 0.435047C15.671 0.525541 15.7776 0.646762 15.8418 0.78256C16.1358 1.42271 16.2275 2.00232 16.1142 2.51998C15.8601 3.68505 15.6236 4.06742 15.3082 4.46046C15.0987 4.72207 14.7824 5.0183 14.3616 5.35325C13.8502 4.42725 13.6415 3.44725 13.7357 2.41857C13.7997 1.7388 14.0394 1.11761 14.4425 0.593336L14.5716 0.432464C14.6204 0.376427 14.6837 0.332109 14.7573 0.302416C14.8309 0.272723 14.9131 0.258325 14.9986 0.260167Z"
                fill="url(#paint1_linear_4830_4295)"
            />
        </g>
        <defs>
            <linearGradient id="paint0_linear_4830_4295" x1="15.5281" y1="52.7339" x2="-2.78053" y2="-9.32379" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#FFD191" />
                <stop offset="0.870192" stopColor="#CC7A00" />
            </linearGradient>
            <linearGradient id="paint1_linear_4830_4295" x1="15.5281" y1="52.7339" x2="-2.78053" y2="-9.32379" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#FFD191" />
                <stop offset="0.870192" stopColor="#CC7A00" />
            </linearGradient>
            <clipPath id="clip0_4830_4295">
                <rect width="29" height="28" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
const icon2 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
        <g clipPath="url(#clip0_4830_4298)">
            <path
                d="M16.9803 21.8251C18.5799 21.9204 19.3188 22.7104 19.0886 23.2837C18.8565 23.857 17.226 25.2969 14.4852 25.6816C11.7463 26.0663 9.03456 25.8907 7.99975 25.8907C6.9669 25.8907 5.74447 25.7488 6.37501 25.2278C7.84119 24.0752 9.50801 23.1835 11.2976 22.5946C13.7018 21.8233 15.3826 21.7262 16.9803 21.8233V21.8251ZM22.6747 14.9601C22.5663 15.6287 21.8487 17.3319 19.7791 18.6242C18.135 19.6551 16.2589 20.3928 14.2608 20.7887C12.7773 21.0912 11.375 21.5039 11.8392 20.6636C12.3034 19.8232 13.874 17.7371 16.1447 16.2711C18.4155 14.8052 19.6128 14.6315 20.6225 14.426C21.6341 14.2206 22.783 14.2953 22.6747 14.962L22.6747 14.9601ZM21.9783 8.05032C22.812 8.05032 22.7559 8.79359 22.5334 9.43231C22.3091 10.0672 21.3555 11.9628 19.7095 13.1169C18.6109 13.8844 17.2201 14.5512 15.5374 15.1151C15.9126 13.0515 16.7173 11.4287 17.9513 10.2484C19.8004 8.47611 21.1447 8.0522 21.9783 8.0522V8.05032ZM18.2395 2.54862C18.5079 2.52356 18.777 2.59032 18.9996 2.73724C19.1016 2.80352 19.1879 2.88985 19.2529 2.99059C19.3179 3.09133 19.3601 3.20419 19.3768 3.32178L19.4116 3.65046C19.5044 4.70746 19.3343 5.76822 18.9145 6.76922C18.2762 8.28191 17.3169 9.48271 16.0403 10.3642C15.7889 9.55742 15.6322 8.88885 15.5761 8.35474C15.491 7.55171 15.491 6.8271 16.0403 4.99508C16.284 4.18082 16.814 3.44502 17.6263 2.78767C17.8008 2.64971 18.0147 2.56632 18.2395 2.54862Z"
                fill="url(#paint0_linear_4830_4298)"
            />
            <path
                d="M14.0022 0.260167C13.8148 0.263016 13.6246 0.324911 13.4647 0.435047C13.3298 0.525541 13.2231 0.646762 13.1589 0.78256C12.8649 1.42271 12.7733 2.00232 12.8865 2.51998C13.1406 3.68505 13.3771 4.06742 13.6925 4.46046C13.902 4.72207 14.2183 5.0183 14.6391 5.35325C15.1505 4.42725 15.3592 3.44725 15.265 2.41857C15.201 1.7388 14.9613 1.11761 14.5582 0.593336L14.4291 0.432464C14.3803 0.376427 14.317 0.332109 14.2434 0.302416C14.1698 0.272723 14.0876 0.258325 14.0022 0.260167Z"
                fill="url(#paint1_linear_4830_4298)"
            />
        </g>
        <defs>
            <linearGradient id="paint0_linear_4830_4298" x1="15.4114" y1="52.7339" x2="-2.89717" y2="-9.32379" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#FFD191" />
                <stop offset="0.870192" stopColor="#CC7A00" />
            </linearGradient>
            <linearGradient id="paint1_linear_4830_4298" x1="15.4114" y1="52.7339" x2="-2.89717" y2="-9.32379" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="0.371018" stopColor="#FFD191" />
                <stop offset="0.870192" stopColor="#CC7A00" />
            </linearGradient>
            <clipPath id="clip0_4830_4298">
                <rect width="29" height="28" fill="white" transform="matrix(-1 0 0 1 28.9998 0.00012207)" />
            </clipPath>
        </defs>
    </svg>
);
export default function Content({ id, data, attr, theme }: any) {
    let { title1, title2, title3, list = [], pc, h5, bg = 'lightgray' } = data;
    // 最多6个
    const newList = list.slice(0, 7);
    const [isBr, setIsBr] = useState(false);
    const [hasSrc, setHasSrc] = useState(pc);
    const [titleLength, setTitleLength] = useState<number>(0);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW > 1440) {
                    // pc
                    setIsBr(false);
                    setHasSrc(pc);
                } else {
                    setIsBr(true);
                    setHasSrc(h5);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, [pc, h5]);
    useEffect(() => {
        const number = [title1.length, title2.length, title3.length].reduce((accumulator, currentValue) => {
            return accumulator + currentValue;
        }, 0);
        setTitleLength(number);
    }, [title1, title2, title3]);
    return (
        <div
            className={`${styles.content} temp-SwiperCardB temp-hide temp-${theme} temp-${id} GtmModuleData-section`}
            id={id}
            data-section-id="editor-SwiperCardB"
            data-section-id2={id}
            data-section-classname=".SwiperCardB-title"
            style={{ backgroundImage: `url(${hasSrc})`, backgroundColor: bg }}
        >
            <div className="content-box">
                <DefaultStyle id={id} attr={attr} />
                {(title1 || title2 || title3) && (
                    <h1 className="SwiperCardB-title">
                        <span className="title1">{title1}</span>
                        <span className="title2">
                            {icon1}
                            {title2}
                            {icon2}
                        </span>
                        {(isBr || titleLength > 50) && <br></br>}
                        <span className="title3">{title3}</span>
                    </h1>
                )}
                <div className={`box box-${newList.length}`}>
                    {newList?.map((item: any, index: number) => {
                        const { label, title, desc } = item;
                        return (
                            <div className="item" key={index}>
                                <div className="item-label">{label}</div>
                                <div className="item-title">{title}</div>
                                <div className="item-desc">{desc}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
